/**
 * 대한민국의 주요 공휴일 목록 (YYYY-MM-DD 형식)
 * @description
 * - 이 목록은 특정 연도에 대한 공휴일을 정의합니다.
 * - 매년 초, 또는 필요시 이 목록을 업데이트해야 합니다.
 * - 주말(토, 일)은 여기에 포함하지 않습니다.
 */
export const publicHolidays: string[] = [
  "2025-08-15",
  "2025-09-06",
  "2025-09-07",
  "2025-09-08",
  "2025-10-03",
  "2025-10-09",
  "2025-12-25",
];
